module.exports = __webpack_public_path__ + "static/media/GelBoxFull.439e4e38.svg";